export default "__VITE_ASSET__CRJWwOUf__"